import React from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import BSL_Dialog from "../components/BSL_Dialog";
import BSL_ControlContainer from "../components/BSL_ControlContainer";
import * as BSL_Common from "../components/BSL_CommonControls";
import ManageProductListControlCodes from "./ManageProductListControlCodes";
import ManageProductListAncillary from "./ManageProductListAncillary";

const useStyles = makeStyles((theme) => ({
    root: {
        flex: 1,
        maxWidth: "90%",
        minWidth: "600px",
    },
    sl_row: {
        flex: 1,
        display: "flex",
        margin: "3px 0px",
        padding: "3px 0px",
        borderBottom: "1px dotted grey",
    },
    sl_row_header: {
        display: "flex",
        width: "100px",
    },
    sl_row_content: {
        display: "flex",
        flexWrap: "wrap",
        flex: "1",
    },
    sl_content: {
        display: "flex",
        flexDirectio: "column",
        flex: "1",
    },
    sl_chip: {
        color: theme.palette.primary.main,
    },
    pair_chip: {
        color: theme.palette.primary.main,
    },
    pair_header: {
        color: theme.palette.primary.main,
        fontSize: "14px",
        fontWeight: 600,
    },
}));

export default function ManageProductListItem(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { row, action, columns, config } = props;
    const [editRow, setEditRow] = React.useState(row);
    const [value2Colours, setValue2Colours] = React.useState("");
    const [value2Image, setValue2Image] = React.useState("");
    const [showControlCodes, setShowControlCodes] = React.useState(false);
    const [showAncillaryItems, setShowAncillaryItems] = React.useState(false);

    const setValue = (parameter) => (value) => {
        let newRow = { ...editRow };
        newRow[parameter] = value;
        setEditRow(newRow);
    };

    let title = "NEW ITEM";
    let saveButtonText = "Add New";
    if (action === "EDIT") {
        title = "EDIT " + row?.["ProductIndex"] + " - " + row?.["ProductDescription"];
        saveButtonText = "Update Item";
    } else if (action === "DUPLICATE") {
        title = "DUPLICATE " + row?.["ProductIndex"] + " - " + row?.["ProductDescription"];
        saveButtonText = "Duplicate Item";
    } else if (action === "VIEW") {
        title = "VIEWING HISTORY DATA FOR " + row?.["ProductIndex"];
        saveButtonText = "CLOSE";
    }

    return (
        <BSL_Dialog
            title={title}
            open={true}
            // onClose={onClose}
            button1Text={saveButtonText}
            onClose={() => {
                props.onClose();
            }}
            button1Click={() => {
                if (!editRow["ProductIndex"]) {
                    alert("Please add an Product index before saving");
                    return;
                }
                if (!editRow["ProductCode"]) {
                    alert("Please add an Lyves Code before saving");
                    return;
                }
                if (!editRow["ProductDescription"]) {
                    alert("Please add an Product Description before saving");
                    return;
                }

                if (action === "DUPLICATE") props.saveValue(editRow, "ADD");
                else if (action === "NEW") props.saveValue(editRow, "ADD");
                else props.saveValue(editRow, action);
                // saveValue(value2, "ADD");
            }}
            button2Text="Cancel"
            button2Click={() => {
                props.onClose();
            }}
            style={{ maxWidth: "initial" }}
            contentStyle={{ background: action === "VIEW" ? "#eeeeee" : "inherit" }}
            fullWidth={true}
            maxWidth={"md"}
        >
            <BSL_Common.SectionRow>
                <BSL_Common.SectionColumn>
                    {columns?.[0]?.editor(
                        row,
                        editRow["GroupingName"],
                        setValue("GroupingName"),
                        () => {},
                        "NO BUTTON"
                    )}
                    {columns?.[2]?.editor(
                        row,
                        editRow["ProductIndex"],
                        setValue("ProductIndex"),
                        () => {},
                        "NO BUTTON"
                    )}
                    {columns?.[6]?.editor(
                        row,
                        editRow["ProductDescription"],
                        setValue("ProductDescription"),
                        () => {},
                        "NO BUTTON"
                    )}
                    {columns?.[7]?.editor(row, editRow["Cost"], setValue("Cost"), () => {}, "NO BUTTON")}
                    {columns?.[8]?.editor(row, editRow["Markup"], setValue("Markup"), () => {}, "NO BUTTON")}
                    {columns?.[9]?.editor(row, editRow["SellingUOM"], setValue("SellingUOM"), () => {}, "NO BUTTON")}
                    {columns?.[13]?.editor(row, editRow["Notes"], setValue("Notes"), () => {}, "NO BUTTON")}
                </BSL_Common.SectionColumn>
                <BSL_Common.SectionColumn>
                    {columns?.[1]?.editor(
                        row,
                        editRow["Image_b64"],
                        setValue("Image_b64"),
                        () => {},
                        value2Image,
                        setValue2Image,
                        "NO BUTTON"
                    )}
                    {columns?.[4]?.editor(row, editRow["Brand"], setValue("Brand"), () => {}, "NO BUTTON")}
                    {columns?.[3]?.editor(row, editRow["ProductCode"], setValue("ProductCode"), () => {}, "NO BUTTON")}
                    {columns?.[5]?.editor(
                        row,
                        editRow["ProductGroup"],
                        setValue("ProductGroup"),
                        () => {},
                        editRow["SubGroup"],
                        setValue("SubGroup"),
                        "NO BUTTON"
                    )}
                    <div style={{ background: "#ecebeb" }}>
                        {columns?.[10]?.editor(
                            row,
                            editRow["Colours"],
                            setValue("Colours"),
                            () => {},
                            value2Colours,
                            setValue2Colours,
                            "NO BUTTON",
                            editRow?.["Brand"] === "CDS" ? config.cdsOffering : config.lldOffering
                        )}
                    </div>
                    {columns?.[15]?.editor(row, editRow["State"], setValue("State"), () => {}, "NO BUTTON")}
                </BSL_Common.SectionColumn>
            </BSL_Common.SectionRow>

            <BSL_Common.SectionRow>
                <BSL_ControlContainer
                    label={"Ancillary Parts"}
                    style={{ color: "white", background: "antiquewhite", borderRadius: "4px", padding: "8px" }}
                    tight={true}
                    helperText={"click to edit ancillary items"}
                >
                    <div
                        className="link"
                        style={{
                            fontSize: "18px",
                        }}
                        onClick={() => {
                            setShowAncillaryItems(true);
                        }}
                    >
                        {editRow["AncillaryParts"] ? (
                            columns?.[11]?.format(editRow["AncillaryParts"], editRow)
                        ) : (
                            <div style={{ fontSize: "66%" }}>"-Add Ancillary Items-"</div>
                        )}
                    </div>
                    {showAncillaryItems && (
                        <ManageProductListAncillary
                            row={editRow}
                            onClose={() => setShowAncillaryItems(false)}
                            saveValue={(row, param, data) => {
                                setShowAncillaryItems(false);
                                setValue("AncillaryParts")(data);
                            }}
                            pricefileDescSummary={config.pricefileDescSummary}
                        />
                    )}
                </BSL_ControlContainer>
                <BSL_ControlContainer
                    label={"Control Codes"}
                    style={{ color: "white", background: "antiquewhite", padding: "8px", borderRadius: "4px" }}
                    tight={true}
                    helperText={"click to edit control codes"}
                >
                    <div
                        className="link"
                        style={{
                            fontSize: "18px",
                        }}
                        onClick={() => {
                            setShowControlCodes(true);
                        }}
                    >
                        {editRow["PromptTextCodes"] ? (
                            columns?.[12]?.format(editRow["PromptTextCodes"], editRow)
                        ) : (
                            <div style={{ fontSize: "66%" }}>"-Add Control Codes-"</div>
                        )}
                    </div>
                    {showControlCodes && (
                        <ManageProductListControlCodes
                            row={editRow}
                            onClose={() => setShowControlCodes(false)}
                            saveValue={(row, param, data) => {
                                setShowControlCodes(false);
                                setValue("PromptTextCodes")(data);
                            }}
                        />
                    )}
                </BSL_ControlContainer>
            </BSL_Common.SectionRow>
        </BSL_Dialog>
    );
}
